import * as React from 'react';

/**
 * Context to provide the current slot element to layout components. There could be several slot context providers
 * rendered at the same time if there are nested layouts.
 */
export const SlotContext = /*#__PURE__*/React.createContext({
  slot: null
});
SlotContext.displayName = 'SlotContext';